
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bhubaneswar",
      function () {
        return require("private-next-pages/bhubaneswar/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bhubaneswar"])
      });
    }
  